/**
 * @generated SignedSource<<e324fda8e25bb500118017e7d979f196>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PromotionProblemEventUpsertInput = {
  count?: number | null;
  durationDays?: number | null;
  durationHours?: number | null;
  offsetHours: number;
  promotionId: string;
};
export type PromotionProblemEventUpsertDialog_promotionProblemEventUpsertMutation$variables = {
  input: PromotionProblemEventUpsertInput;
};
export type PromotionProblemEventUpsertDialog_promotionProblemEventUpsertMutation$data = {
  readonly promotionProblemEventUpsert: {
    readonly count: number;
    readonly durationDays: number | null;
    readonly durationHours: number | null;
    readonly offsetHours: number;
  };
};
export type PromotionProblemEventUpsertDialog_promotionProblemEventUpsertMutation = {
  response: PromotionProblemEventUpsertDialog_promotionProblemEventUpsertMutation$data;
  variables: PromotionProblemEventUpsertDialog_promotionProblemEventUpsertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PromotionProblemEvent",
    "kind": "LinkedField",
    "name": "promotionProblemEventUpsert",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationHours",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationDays",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offsetHours",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PromotionProblemEventUpsertDialog_promotionProblemEventUpsertMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PromotionProblemEventUpsertDialog_promotionProblemEventUpsertMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "325c021861eff5d2c010f45d78fb7257",
    "id": null,
    "metadata": {},
    "name": "PromotionProblemEventUpsertDialog_promotionProblemEventUpsertMutation",
    "operationKind": "mutation",
    "text": "mutation PromotionProblemEventUpsertDialog_promotionProblemEventUpsertMutation(\n  $input: PromotionProblemEventUpsertInput!\n) {\n  promotionProblemEventUpsert(input: $input) {\n    durationHours\n    durationDays\n    count\n    offsetHours\n  }\n}\n"
  }
};
})();

(node as any).hash = "293170eb81320524c3708e4b799d2091";

export default node;
